module.exports = __webpack_public_path__ + "static/media/Raleway-Bold.2f45ecbb.woff";